// extracted by mini-css-extract-plugin
export default {"mb0":"DataLinkModal_mb0__MFUco"};